"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Vector = /** @class */ (function () {
    function Vector(xOrAngle, yOrMagnitude, polar) {
        if (polar) {
            this._x = Vector.x(xOrAngle, yOrMagnitude);
            this._y = Vector.y(xOrAngle, yOrMagnitude);
        }
        else {
            this._x = xOrAngle;
            this._y = yOrMagnitude;
            this._angle = this.angle;
            this._magnitude = this.magnitude;
        }
    }
    Vector.clone = function (v) {
        var clone = new Vector(0, 0);
        clone._x = v._x;
        clone._y = v._y;
        return clone;
    };
    Vector.random = function () {
        return Vector.polar(Math.PI * 2 * Math.random(), 1);
    };
    Vector.cartesian = function (x, y) {
        return new Vector(x, y);
    };
    Vector.polar = function (angle, magnitude) {
        return new Vector(angle, magnitude, true);
    };
    Vector.dist = function (v1, v2) {
        var v2x = v2 ? v2.x : 0;
        var v2y = v2 ? v2.y : 0;
        return Math.sqrt(Math.pow((v1.x - v2x), 2) + Math.pow((v1.y - v2y), 2));
    };
    Vector.x = function (angle, magnitude) {
        return magnitude * Math.cos(angle);
    };
    Vector.y = function (angle, magnitude) {
        return magnitude * Math.sin(angle);
    };
    Vector.dot = function (v1, v2) {
        return v1.x * v1.y + v2.x * v2.y;
    };
    Vector.zero = function () {
        return Vector.cartesian(0, 0);
    };
    Vector.prototype.add = function (b) {
        if (b instanceof Vector) {
            this.x += b.x;
            this.y += b.y;
        }
        else {
            this.x += b;
            this.y += b;
        }
        return this;
    };
    Vector.prototype.mult = function (n) {
        this.x *= n;
        this.y *= n;
        return this;
    };
    Vector.prototype.sub = function (b) {
        if (b instanceof Vector) {
            this.add(Vector.clone(b).mult(-1));
        }
        else {
            this.add(-b);
        }
        return this;
    };
    Vector.prototype.div = function (n) {
        this.x /= n;
        this.y /= n;
        return this;
    };
    Vector.prototype.clone = function () {
        return Vector.clone(this);
    };
    Vector.prototype.copyFrom = function (v) {
        this._x = v._x;
        this._y = v._y;
        return this;
    };
    Vector.prototype.dot = function (v) {
        return Vector.dot(this, v);
    };
    Vector.prototype.limit = function (magnitude) {
        this.magnitude = Math.min(this.magnitude, magnitude);
        return this;
    };
    Vector.prototype.normalize = function () {
        if (this.magnitude > 0) {
            this.div(this.magnitude);
        }
        return this;
    };
    Object.defineProperty(Vector.prototype, "x", {
        get: function () {
            return this._x;
        },
        set: function (x) {
            this.setX(x);
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.setX = function (x) {
        this._x = x;
        this._magnitude = undefined;
        this._angle = undefined;
        return this;
    };
    Object.defineProperty(Vector.prototype, "y", {
        get: function () {
            return this._y;
        },
        set: function (y) {
            this.setY(y);
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.setY = function (y) {
        this._y = y;
        this._magnitude = undefined;
        this._angle = undefined;
        return this;
    };
    Vector.prototype.setCartesian = function (x, y) {
        this.setX(x);
        this.setY(y);
        return this;
    };
    Object.defineProperty(Vector.prototype, "angle", {
        get: function () {
            this._angle =
                this._angle === undefined ? Math.atan2(this.y, this.x) : this._angle;
            return this._angle;
        },
        set: function (angle) {
            this.setAngle(angle);
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.setAngle = function (angle) {
        if (this._angle !== angle) {
            var magnitude = this.magnitude;
            this._x = Vector.x(angle, magnitude);
            this._y = Vector.y(angle, magnitude);
            this._angle = angle;
        }
        return this;
    };
    Object.defineProperty(Vector.prototype, "magnitude", {
        get: function () {
            this._magnitude =
                this._magnitude === undefined ? Vector.dist(this) : this._magnitude;
            return this._magnitude;
        },
        set: function (magnitude) {
            this.setMagnitude(magnitude);
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.setMagnitude = function (magnitude) {
        if (this._magnitude !== magnitude) {
            var angle = this.angle;
            this._x = Vector.x(angle, magnitude);
            this._y = Vector.y(angle, magnitude);
            this._magnitude = magnitude;
        }
        return this;
    };
    Vector.prototype.setPolar = function (angle, magnitude) {
        this._x = Vector.x(angle, magnitude);
        this._y = Vector.y(angle, magnitude);
        this._angle = angle;
        this._magnitude = magnitude;
        return this;
    };
    return Vector;
}());
exports.Vector = Vector;
